import BossModeBanner from './BossModeBanner.component';

export default BossModeBanner;